module.exports = __webpack_public_path__ + "static/8754bb60c0ad35c7ead3c0086c1735b9f091034ab8010f2ef4a7b5bd40266106-f171b0ad7ac0286af6caedc5fa00e959.png";